import { gql } from "@apollo/client";
import { ICmsAirport, ICmsRoute } from "@common/models/CMS";

export interface IRouteData {
  route?: ICmsRoute[];
  airport?: ICmsAirport[];
  englishAirport?: ICmsAirport[];
}

export const GET_ROUTE = gql`
  query RouteData($culture: String!, $status: Status!) {
    route (status: $status) {
      code {
        code
      }
      availableForIB
      locality
      bookingProvider
      path
      weekSchedule {
        friday
        monday
        saturday
        sunday
        thursday
        tuesday
        wednesday
      }
    }
    airport(where: {localization: {culture: $culture}}, status: $status) {
      sortIndex
      code {
        code
      }
      name
      onlineCheckinProfile {
        contentItemIds
      }
      forecaWeatherId
      location {
        latitude
        longitude
      }
      city {
        contentItems {
          __typename
          ... on City {
            name
            code {
              code
            }
            cover {
              paths
              texts
            }
            country {
              contentItems {
                __typename
                ... on Country {
                  code {
                    code
                  }
                }
              }
            }
          }
        }
      }
      terminals {
        contentItems {
          __typename
          ... on Terminal {
            displayText
            default
            direction
            address
            location {
              latitude
              longitude
            }
            defaultDestinations {
              contentItems {
                __typename
                ... on Airport {
                  code {
                    code
                  }
                }
              }
            }
          }
        }
      }
    }
    englishAirport: airport(where: {localization: {culture: "en-US"}}, status: $status) {
      sortIndex
      code {
        code
      }
      name
      location {
        latitude
        longitude
      }
      city {
        contentItems {
          __typename
          ... on City {
            name
            country {
              contentItems {
                __typename
                ... on Country {
                  code {
                    code
                  }
                }
              }
            }
          }
        }
      }
      terminals {
        contentItems {
          __typename
          ... on Terminal {
            displayText
            default
            direction
            address
            location {
              latitude
              longitude
            }
          }
        }
      }
    }
  }  
`;
